import { Injectable } from "@angular/core";
import { RemoteGatewayFactory } from "../../gateways/remote-gateway-factory";
import { ProductTypeParser } from "../parsers/pbm/benefit/product-type.parser";
import { ProductSubtypeParser } from "../parsers/pbm/benefit/product-subtype.parser";
import { BackendUrl } from "../../models/domains/urls/back-end.url";
import { PagingRequest } from "../../models/domains/paginator/paging-request";
import { PageableResult } from "../../models/domains/paginator/pageable-result";
import { SearchProductsByParser } from "../parsers/pbm/benefit/search-products-by.parser";
import { ProductCategoryParser } from "../parsers/pbm/benefit/product-category.parser";

@Injectable()
export class ProductRepository {
  constructor(
    private remoteGatewayFactory: RemoteGatewayFactory,
    private searchProductsByParser: SearchProductsByParser,
    private productTypeParser: ProductTypeParser,
    private productSubtypeParser: ProductSubtypeParser,
    private productCategoryParser: ProductCategoryParser,
  ) {}

  public async searchProductBy(pagingRequest: PagingRequest): Promise<PageableResult> {
    const body = {
      StartIndex: pagingRequest.getStart(),
      TotalPerPages: pagingRequest.getEnd(),
      ProductName: pagingRequest.getOptions()[0].getValue(),
      FilterText: pagingRequest.getOptions()[0].getValue(),
      Ean: pagingRequest.getOptions()[1].getValue(),
    };

    const headers = { "Content-Type": "application/json" };

    try {
      const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();

      const backendUrl = new BackendUrl(`/api/products/simple?query=${body.Ean || body.FilterText}&take=${body.TotalPerPages}&skip=${body.StartIndex}`);

      const payload = await remoteGateway.getWithHeaders(backendUrl, headers);

      return this.searchProductsByParser.parse(payload);
    } catch (err) {
      return await Promise.reject(err);
    }
  }

  public async getProductTypes(): Promise<any> {
    const headers = { "Content-Type": "application/json" };

    try {
      const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();

      const data = await remoteGateway.getWithHeaders(new BackendUrl("/api/products/types"), headers);

      return this.productTypeParser.parse(data);
    } catch (error) {
      return await Promise.reject(error);
    }
  }

  public async getProductSubtypeByType(typeKey: string): Promise<any> {
    const headers = { "Content-Type": "application/json" };

    try {
      const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();

      const data = await remoteGateway.getWithHeaders(new BackendUrl("/api/products/type/" + typeKey + "/subtypes"), headers);

      return this.productSubtypeParser.parse(data);
    } catch (error) {
      return await Promise.reject(error);
    }
  }

  public async getProductCategoryList(): Promise<any> {
    const headers = { "Content-Type": "application/json" };

    try {
      const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();

      const data = await remoteGateway.getWithHeaders(new BackendUrl("/api/products/categories"), headers);

      return this.productCategoryParser.parse(data);
    } catch (error) {
      return await Promise.reject(error);
    }
  }
}
